module.exports = __webpack_public_path__ + "img/ywyk-instructions08.880bf423.jpg";